import React from 'react'

interface Props {
  idx: number
  width?: number | string
  height?: number | string
  top?: number | string
  left?: number | string
  bottom?: number | string
  right?: number | string
  isLight?: boolean
  transform?: string
}

export default function StPatricksDayEmptyClover(props: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 158.97 174.42"
      style={{
        position: 'absolute',
        width: props.width,
        height: props.height,
        bottom: props.bottom,
        top: props.top,
        right: props.right,
        left: props.left,
        transform: props.transform,
      }}
    >
      <defs>
        <style>{`.cls-patrick-2-${props.idx} {fill:#04b364;}`}</style>
      </defs>
      <g id="Layer_2" data-name="Layer 2">
        <g id="MASQUE">
          <path
            className={`cls-patrick-2-${props.idx}`}
            d="M54.71,105.83c-1.66,1.18-2.88,2-4.11,2.91-5.06,3.55-10.29,6.79-16.28,8.58-10.55,3.16-23.27-1.19-29.43-10.26-5.12-7.54-5.19-15.43-1-23.47A3.11,3.11,0,0,0,4.11,81c-9.56-14-1.44-30.65,14-35.6,7.68-2.46,15-1.28,22,2.17,3.7,1.82,7.22,4,10.82,6a3.41,3.41,0,0,0,1.88.58c-.71-1-1.42-1.95-2.13-2.94-3.5-4.92-6.72-10-8.67-15.76-4.1-12.12,1.3-26.35,12.2-32.05C61.31-.27,68.38.16,75.33,3.87c1,.5,1.68,1,2.83.2,13.38-9.09,29-2,34.66,12,3.31,8.23,2.38,16.22-1.46,24-2.09,4.24-4.49,8.32-6.91,12.77l1.5-.92c5.16-3.07,10.08-6.68,15.54-9.08,12.24-5.41,27.05-.6,33.48,10.39,4.26,7.27,4,14.66.16,22-.48.93-1.06,1.65-.26,2.83,9.5,13.89,1.29,29.86-12.5,34.93-8.09,3-15.82,2-23.41-1.6-.64-.3-1.28-.58-1.92-.85a6.51,6.51,0,0,0-1.05-.19c1.19,1.26,2.09,2.26,3,3.22a170.17,170.17,0,0,1,36,54.73c1.08,2.59.24,4.9-2,5.79s-4.49-.24-5.51-3.06a164.25,164.25,0,0,0-25.4-46.65c-2.68-3.4-5.57-6.65-8.37-10a2.5,2.5,0,0,0-1.43-.88c.79,1.46,1.58,2.91,2.35,4.38,5.28,10.12,5.07,20.1-1.2,29.68C106.67,158,94.26,160.89,83.34,155a2.76,2.76,0,0,0-2.38,0c-14.11,9.48-30.46,1.24-35.4-13.77-2.55-7.74-1.45-15.1,2-22.2C49.71,114.67,52.12,110.57,54.71,105.83Zm53.09-4.9c4.36,2.41,8.15,4.67,12.09,6.65,6.19,3.1,12.61,4.39,19.51,2.32C153.85,105.58,159.48,91,151,79.34a3.35,3.35,0,0,1-.16-4.47c3.76-5.81,4.6-12,1.52-18.36-2.61-5.4-7.08-8.74-12.65-10.7C132,43.08,124.82,44.74,118,48.66c-9.38,5.35-17.43,12.39-25.19,19.8a57.88,57.88,0,0,1-4.39,4.2,2.64,2.64,0,0,1-2.52.14c-.47-.39-.49-1.74-.23-2.5a7.37,7.37,0,0,1,1.67-2.13c7.55-8.78,14.68-17.85,19.93-28.25,3.88-7.69,5.21-15.45,1.49-23.62C103.17,4.16,90.07.24,79.63,7.81c-1.85,1.34-3.1,1.34-5,.15-9.4-5.83-20-3.48-26,5.78C43.67,21.32,43.14,29.31,47,37.53c4.14,8.86,10.26,16.33,16.74,23.52,2.91,3.22,6,6.24,8.91,9.49.49.55.19,1.81.25,2.75a8.27,8.27,0,0,1-2.63,0c-.74-.25-1.3-1-1.94-1.56-8.94-7.58-18.06-14.87-28.62-20.14C31.49,47.49,23.32,46.51,15,51,3.52,57.1.61,69.51,8.26,79.93c1.09,1.47.88,2.52,0,3.94-5.59,8.92-4.19,19,3.58,25.08,7.51,5.83,15.79,7.21,24.69,3.49A67.73,67.73,0,0,0,54,101.29c5.23-4.42,10.19-9.17,15.27-13.77.31-.29.61-.58.9-.89C71,85.69,72.06,85,73.24,86s.56,2.26-.29,3.29c-2.82,3.39-5.72,6.72-8.45,10.18-5.48,6.94-10.45,14.21-14,22.37-3.66,8.34-3.32,16.39,1.69,24,6.49,9.89,18.1,12,27.38,5.1,1.72-1.28,2.89-1.23,4.64-.14,9.67,6,20.36,3.59,26.44-6,4.68-7.42,5.17-15.24,1.48-23.24-4.12-9-10.31-16.46-16.82-23.71-2.76-3.07-5.68-6-8.55-9-.95-1-1.75-2-.6-3.26s2.28-.41,3.29.42c.38.31.73.65,1.12,1Z"
          />
        </g>
      </g>
    </svg>
  )
}
